import { render, staticRenderFns } from "./ComboboxInstituicao.vue?vue&type=template&id=721a67cd&"
import script from "./ComboboxInstituicao.vue?vue&type=script&lang=js&"
export * from "./ComboboxInstituicao.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports